// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container_metrics {\n  margin-top: 1rem;\n  background: #414141;\n  border-radius: 1rem;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
